const state = {
  errorFlg: false,
  addressFormSelected: '',
  addressList: [],
  address: '',
  buildingName: '',
  largeItems: [],
  mediumItems: [],
  addMediumItem: {},
  medium_box_cnt: 0,
  smallItems: {},
  specificDate: '',
  specificTime: '',
  is_large: 0,
  sei_kj: '',
  mei_kj: '',
  sei_kn: '',
  mei_kn: '',
  pickupTell: '',
  pickupTell2: '',
  email: '',
  birthday: null,
  gender: '',
  itemsDataTax: {},
  smallTag: '',
  settings: {},
  enquete: {},
  erasePcNum: 0,
  contractorSei_kj: '',
  contractorMei_kj: '',
  contractorSei_kn: '',
  contractorMei_kn: '',
  companyName: '',
  department: '',
  contractCompanyName: '',
  contractDepartment: '',
  contractCompanyZipcode: '',
  contractCompanyAddress: '',
  contractCompanyTell: '',
  selectEmployee: '',
  selectIndustry: '',
  codeInfo: {},
  checkContractor: false,
  downloadTarget: '',
  numOfSmallItemsTag: '',
  referralCompanyCode: null
};

const getters = {
  errorFlg: state => (state.errorFlg ? state.errorFlg : false),
  addressFormSelected: state => (state.addressFormSelected ? state.addressFormSelected : ""),
  addressList: state => (state.addressList ? state.addressList : ""),
  address: state => (state.address ? state.address : ""),
  buildingName: state => (state.buildingName ? state.buildingName : ""),
  largeItems: state => (state.largeItems ? state.largeItems : ""),
  mediumItems: state => (state.mediumItems ? state.mediumItems : ""),
  addMediumItem: state => (state.addMediumItem ? state.addMediumItem : ""),
  medium_box_cnt: state => (state.medium_box_cnt),
  smallItems: state => (state.smallItems ? state.smallItems : ""),
  specificDate: state => (state.specificDate ? state.specificDate : ""),
  specificTime: state => (state.specificTime ? state.specificTime : ""),
  is_large: state => (state.is_large ? state.is_large : ""),
  sei_kj: state => (state.sei_kj ? state.sei_kj : ""),
  mei_kj: state => (state.mei_kj ? state.mei_kj : ""),
  sei_kn: state => (state.sei_kn ? state.sei_kn : ""),
  mei_kn: state => (state.mei_kn ? state.mei_kn : ""),
  pickupTell: state => (state.pickupTell ? state.pickupTell : ""),
  pickupTell2: state => (state.pickupTell2 ? state.pickupTell2 : ""),
  email: state => (state.email ? state.email : ""),
  birthday: state => (state.birthday ? state.birthday : null),
  gender: state => (state.gender ? state.gender : ""),
  itemsDataTax: state => (state.itemsDataTax ? state.itemsDataTax : ""),
  smallTag: state => (state.smallTag),
  settings: state => (state.settings),
  enquete: state => (state.enquete),
  erasePcNum: state => (state.erasePcNum),
  contractorSei_kj: state => (state.contractorSei_kj),
  contractorMei_kj: state => (state.contractorMei_kj),
  contractorSei_kn: state => (state.contractorSei_kn),
  contractorMei_kn: state => (state.contractorMei_kn),
  companyName: state => (state.companyName),
  department: state => (state.department),
  contractCompanyName: state => (state.contractCompanyName),
  contractDepartment: state => (state.contractDepartment),
  contractCompanyZipcode: state => (state.contractCompanyZipcode),
  contractCompanyAddress: state => (state.contractCompanyAddress),
  contractCompanyTell: state => (state.contractCompanyTell),
  selectEmployee: state => (state.selectEmployee),
  selectIndustry: state => (state.selectIndustry),
  codeInfo: state => (state.codeInfo),
  checkContractor: state => (state.checkContractor),
  downloadTarget: state => (state.downloadTarget),
  numOfSmallItemsTag: state => (state.numOfSmallItemsTag),
  referralCompanyCode: state => (state.referralCompanyCode)
};

const mutations = {
  setErrorFlg(state, errorFlg) {
    state.errorFlg = errorFlg;
  },
  setAddressFormSelected(state, addressFormSelected) {
    state.addressFormSelected = addressFormSelected;
  },
  setAddressList(state, addressList) {
    state.addressList = addressList;
  },
  setAddress(state, address) {
    state.address = address;
  },
  setBuildingName(state, buildingName) {
    state.buildingName = buildingName;
  },
  setLargeItems(state, largeItems) {
    state.largeItems = largeItems;
  },
  setMediumItems(state, mediumItems) {
    state.mediumItems = mediumItems;
  },
  setAddMediumItem(state, addMediumItem) {
    state.addMediumItem = addMediumItem;
  },
  setMedium_box_cnt(state, medium_box_cnt) {
    state.medium_box_cnt = medium_box_cnt;
  },
  setSmallItems(state, smallItems) {
    state.smallItems = smallItems;
  },
  setSpecificDate(state, specificDate) {
    state.specificDate = specificDate;
  },
  setSpecificTime(state, specificTime) {
    state.specificTime = specificTime;
  },
  setIs_large(state, is_large) {
    state.is_large = is_large;
  },
  setSei_kj(state, sei_kj) {
    state.sei_kj = sei_kj;
  },
  setMei_kj(state, mei_kj) {
    state.mei_kj = mei_kj;
  },
  setSei_kn(state, sei_kn) {
    state.sei_kn = sei_kn;
  },
  setMei_kn(state, mei_kn) {
    state.mei_kn = mei_kn;
  },
  setPickupTell(state, pickupTell) {
    state.pickupTell = pickupTell;
  },
  setPickupTell2(state, pickupTell2) {
    state.pickupTell2 = pickupTell2;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setBirthday(state, birthday) {
    state.birthday = birthday;
  },
  setGender(state, gender) {
    state.gender = gender;
  },
  setItemsDataTax(state, itemsDataTax) {
    state.itemsDataTax = itemsDataTax;
  },
  setSmallTag(state, smallTag) {
    state.smallTag = smallTag;
  },
  setSettings(state, settings) {
    state.settings = settings;
  },
  setEnquete(state, enquete) {
    state.enquete = enquete;
  },
  setErasePcNum(state, erasePcNum) {
    state.erasePcNum = erasePcNum;
  },
  setContractorSei_kj(state, contractorSei_kj) {
    state.contractorSei_kj = contractorSei_kj;
  },
  setContractorMei_kj(state, contractorMei_kj) {
    state.contractorMei_kj = contractorMei_kj;
  },
  setContractorSei_kn(state, contractorSei_kn) {
    state.contractorSei_kn = contractorSei_kn;
  },
  setContractorMei_kn(state, contractorMei_kn) {
    state.contractorMei_kn = contractorMei_kn;
  },
  setCompanyName(state, companyName) {
    state.companyName = companyName;
  },
  setDepartment(state, department) {
    state.department = department;
  },
  setContractCompanyName(state, contractCompanyName) {
    state.contractCompanyName = contractCompanyName;
  },
  setContractDepartment(state, contractDepartment) {
    state.contractDepartment = contractDepartment;
  },
  setContractCompanyZipcode(state, contractCompanyZipcode) {
    state.contractCompanyZipcode = contractCompanyZipcode;
  },
  setContractCompanyAddress(state, contractCompanyAddress) {
    state.contractCompanyAddress = contractCompanyAddress;
  },
  setContractCompanyTell(state, contractCompanyTell) {
    state.contractCompanyTell = contractCompanyTell;
  },
  setSelectEmployee(state, selectEmployee) {
    state.selectEmployee = selectEmployee;
  },
  setSelectIndustry(state, selectIndustry) {
    state.selectIndustry = selectIndustry;
  },
  setCodeInfo(state, codeInfo) {
    state.codeInfo = codeInfo;
  },
  setCheckContractor(state, checkContractor) {
    state.checkContractor = checkContractor;
  },
  setDownloadTarget(state, downloadTarget) {
    state.downloadTarget = downloadTarget;
  },
  setNumOfSmallItemsTag(state, numOfSmallItemsTag) {
    state.numOfSmallItemsTag = numOfSmallItemsTag;
  },
  setReferralCompanyCode(state, referralCompanyCode) {
    state.referralCompanyCode = referralCompanyCode;
  }
};

const actions = {
  errorFlg(context, errorFlg) {
    context.commit("setErrorFlg", errorFlg);
  },
  addressFormSelected(context, addressFormSelected) {
    context.commit("setAddressFormSelected", addressFormSelected);
  },
  addressList(context, addressList) {
    context.commit("setAddressList", addressList);
  },
  address(context, address) {
    context.commit("setAddress", address);
  },
  buildingName(context, buildingName) {
    context.commit("setBuildingName", buildingName);
  },
  largeItems(context, largeItems) {
    context.commit("setLargeItems", largeItems);
  },
  mediumItems(context, mediumItems) {
    context.commit("setMediumItems", mediumItems);
  },
  addMediumItem(context, addMediumItem) {
    context.commit("setAddMediumItem", addMediumItem);
  },
  medium_box_cnt(context, medium_box_cnt) {
    context.commit("setMedium_box_cnt", medium_box_cnt);
  },
  smallItems(context, smallItems) {
    context.commit("setSmallItems", smallItems);
  },
  specificDate(context, specificDate) {
    context.commit("setSpecificDate", specificDate);
  },
  specificTime(context, specificTime) {
    context.commit("setSpecificTime", specificTime);
  },
  is_large(context, is_large) {
    context.commit("setIs_large", is_large);
  },
  sei_kj(context, sei_kj) {
    context.commit("setSei_kj", sei_kj);
  },
  mei_kj(context, mei_kj) {
    context.commit("setMei_kj", mei_kj);
  },
  sei_kn(context, sei_kn) {
    context.commit("setSei_kn", sei_kn);
  },
  mei_kn(context, mei_kn) {
    context.commit("setMei_kn", mei_kn);
  },
  pickupTell(context, pickupTell) {
    context.commit("setPickupTell", pickupTell);
  },
  pickupTell2(context, pickupTell2) {
    context.commit("setPickupTell2", pickupTell2);
  },
  email(context, email) {
    context.commit("setEmail", email);
  },
  birthday(context, birthday) {
    context.commit("setBirthday", birthday);
  },
  gender(context, gender) {
    context.commit("setGender", gender);
  },
  itemsDataTax(context, itemsDataTax) {
    context.commit("setItemsDataTax", itemsDataTax);
  },
  smallTag(context, smallTag) {
    context.commit('setSmallTag', smallTag);
  },
  settings(context, settings) {
    context.commit('setSettings', settings);
  },
  enquete(context, enquete) {
    context.commit('setEnquete', enquete);
  },
  erasePcNum(context, erasePcNum) {
    context.commit('setErasePcNum', erasePcNum);
  },
  contractorSei_kj(context, contractorSei_kj) {
    context.commit('setContractorSei_kj', contractorSei_kj);
  },
  contractorMei_kj(context, contractorMei_kj) {
    context.commit('setContractorMei_kj', contractorMei_kj);
  },
  contractorSei_kn(context, contractorSei_kn) {
    context.commit('setContractorSei_kn', contractorSei_kn);
  },
  contractorMei_kn(context, contractorMei_kn) {
    context.commit('setContractorMei_kn', contractorMei_kn);
  },
  companyName(context, companyName) {
    context.commit('setCompanyName', companyName);
  },
  department(context, department) {
    context.commit('setDepartment', department);
  },
  contractCompanyName(context, contractCompanyName) {
    context.commit('setContractCompanyName', contractCompanyName);
  },
  contractDepartment(context, contractDepartment) {
    context.commit('setContractDepartment', contractDepartment);
  },
  contractCompanyZipcode(context, contractCompanyZipcode) {
    context.commit('setContractCompanyZipcode', contractCompanyZipcode);
  },
  contractCompanyAddress(context, contractCompanyAddress) {
    context.commit('setContractCompanyAddress', contractCompanyAddress);
  },
  contractCompanyTell(context, contractCompanyTell) {
    context.commit('setContractCompanyTell', contractCompanyTell);
  },
  selectEmployee(context, selectEmployee) {
    context.commit('setSelectEmployee', selectEmployee);
  },
  selectIndustry(context, selectIndustry) {
    context.commit('setSelectIndustry', selectIndustry);
  },
  codeInfo(context, codeInfo) {
    context.commit('setCodeInfo', codeInfo);
  },
  checkContractor(context, checkContractor) {
    context.commit('setCheckContractor', checkContractor);
  },
  downloadTarget(context, downloadTarget) {
    context.commit('setDownloadTarget', downloadTarget);
  },
  numOfSmallItemsTag(context, numOfSmallItemsTag) {
    context.commit('setNumOfSmallItemsTag', numOfSmallItemsTag);
  },
  referralCompanyCode(context, referralCompanyCode) {
    context.commit('setReferralCompanyCode', referralCompanyCode);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
